import {
  GET_DOWNLOAD_HISTORY_REQUEST,
  GET_DOWNLOAD_HISTORY_SUCCESS,
  GET_DOWNLOAD_HISTORY_FAILURE,
  GET_DOWNLOAD_HISTORY_DETAIL_REQUEST,
  GET_DOWNLOAD_HISTORY_DETAIL_SUCCESS,
  GET_DOWNLOAD_HISTORY_DETAIL_FAILURE,
  GET_DOWNLOAD_HISTORY_OVERVIEW_REQUEST,
  GET_DOWNLOAD_HISTORY_OVERVIEW_SUCCESS,
  GET_DOWNLOAD_HISTORY_OVERVIEW_FAILURE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils';
import { buildSummaryKey } from '../../utils/downloadHistoryUtils';
const { OrderedMap } = require('immutable');

const initialState = {
  pageInfo: {},
  downloadHistory: OrderedMap({}),
  isLoading: false,
  detail: [],
  detailPageInfo: {},
  isLoadingDetail: false,
  overview: {},
  isLoadingOverview: false,
  message: '',
  errorMessage: '',
}

const downloadHistory = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOWNLOAD_HISTORY_REQUEST: {
      return {
        ...state,
        isLoading: true,
        message: '',
        errorMessage: '',
      }
    }
    case GET_DOWNLOAD_HISTORY_SUCCESS: {
      let list = action.payload.overwrite ? OrderedMap({}) : state.downloadHistory;
      action.payload.data.forEach(item => {
        // サマリーはid列を持たないため、(ownership_user_id, instructed_at)からキーを生成する
        list = list.set(buildSummaryKey(item), item);
      })
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: '',
        downloadHistory: list,
        pageInfo: action.payload.pageInfo,
      }
    }
    case GET_DOWNLOAD_HISTORY_FAILURE: {
      return {
        ...state,
        isLoading: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    }
    case GET_DOWNLOAD_HISTORY_DETAIL_REQUEST: {
      return {
        ...state,
        isLoadingDetail: true,
        detail: [],
        errorMessage: '',
      }
    }
    case GET_DOWNLOAD_HISTORY_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoadingDetail: false,
        detail: action.payload.data,
        detailPageInfo: action.payload.pageInfo,
      }
    }
    case GET_DOWNLOAD_HISTORY_DETAIL_FAILURE: {
      return {
        ...state,
        isLoadingDetail: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    }
    case GET_DOWNLOAD_HISTORY_OVERVIEW_REQUEST: {
      return {
        ...state,
        isLoadingOverview: true,
      }
    }
    case GET_DOWNLOAD_HISTORY_OVERVIEW_SUCCESS: {
      return {
        ...state,
        isLoadingOverview: false,
        overview: action.payload.overview,
      }
    }
    case GET_DOWNLOAD_HISTORY_OVERVIEW_FAILURE: {
      return {
        ...state,
        isLoadingOverview: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    }
    default:
      return state;
  }
}

export default downloadHistory;



// WEBPACK FOOTER //
// ./src/redux/reducers/downloadHistory.js